module.exports = __webpack_public_path__ + "img/category-management-icon4.976b2f04.svg";